export default "__VITE_ASSET__Cbn9nZv2__"